/**
 *
 * @param {Boolean} bool
 * @returns toggled boolean
 */
export const toggleBoolean = (bool) => !bool;

/**
 *
 * @returns query params present in browser url
 */
export const getURLParams = () => {
  let params = {};
  if (window.location.hash.startsWith('#/?')) {
    const [, query] = window.location.hash.split('#')[1].split('?');
    params = Object.fromEntries(new URLSearchParams(query));
  } else {
    const urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
  }
  return params;
};
